import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { DateRangePickerActionButtonsWrapper } from './date-range-picker-action-buttons';
import { getStartAndEndDates } from '../date-range-picker';
import { Typography } from '../../typography';

export interface IDateRangePickerFooterProps extends IBaseComponentProps<HTMLDivElement> {
    value?: string;
    separator: string;
    applyButtonLabel?: string;
    resetButtonLabel?: string;
    onResetClick: () => void;
    onApplyClick: () => void;
}

function DateRangePickerFooterBase(props: IDateRangePickerFooterProps) {
    const { value, onResetClick, onApplyClick, separator, className, resetButtonLabel, applyButtonLabel } = props;
    return (
        <div className={className}>
            {value && <DateRangePickerSummary>{value}</DateRangePickerSummary>}
            <DateRangePickerActionButtonsWrapper
                resetButtonLabel={resetButtonLabel}
                applyButtonLabel={applyButtonLabel}
                onResetClick={onResetClick}
                onApplyClick={onApplyClick}
                isApplyButtonDisabled={isApplyButtonDisabled({ value, separator })} />
        </div>
    );
}

function isApplyButtonDisabled(props: Pick<IDateRangePickerFooterProps, 'value' | 'separator'>) {
    const { value, separator } = props;
    const values = getStartAndEndDates(value!, separator);
    const [startDate, endDate] = values;
    return !(startDate && endDate);
}

const DateRangePickerSummary = styled(Typography.Medium).attrs(() => ({
    className: String('ap-dateRangePicker-summary')
}))`
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
    margin: ${({ theme: { semantics: { gap } } }) => gap.xl};
`;

export const DateRangePickerFooter = styled(DateRangePickerFooterBase).attrs(() => ({
    className: String('ap-dateRangePicker-footer')
}))`
    display: flex;
    border-top-style: 'solid';
    border-top-width: '1px';
    border-top-color: ${({ theme: { dateRangePicker: { colors } } }) => colors.sectionDividerColor};
    align-items: center;
    justify-content: flex-end;
    height: 77px;
`;
